import store from '@/store'

export default (request) => {
  const csrfToken = store.getters['app/getXCsrfToken']
  if (csrfToken) {
    request.headers['X-CSRF-Token'] = csrfToken
  }
  return request
}



// WEBPACK FOOTER //
// ./src/services/interceptors/request-post.js